import { render, staticRenderFns } from "./wait-ship-order-detail.vue?vue&type=template&id=94c8d07e&"
import script from "./wait-ship-order-detail.vue?vue&type=script&lang=js&"
export * from "./wait-ship-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports